import 'react-dates/initialize';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import {BounceLoader} from 'react-spinners';
import Navigator from 'components/NavigatorComponent';
import PostCardComponent from 'components/PostCardComponent'
import API from 'sources/API';
import Moment from 'moment';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import { DayPickerRangeController } from 'react-dates';

require('react-dates/lib/css/_datepicker.css');
require('./Checkout.scss');
require('styles/SweetLoading.scss');

const CustomInfoPanel = () => (
  <div
    style={{
      padding: '10px 21px',
      borderTop: '1px solid #dce0e0',
      color: 'olivedrab',
      fontSize: '12px'
    }}
  >
    &#x2755; 请注意核对出行日期,建议空余1～2月时间招募
  </div>
);

class CheckoutComponent extends Component{
  constructor(props) {
    super(props);
    let {state} = this.props.location;
    let {product,team}  = state;
    let userStore = UserStore.getState();
    this.state = {
      product: product,
      team: team,
      startDate: Moment(),
      endDate: Moment().add(product.days?product.days:12,'day'),
      focusedInput: 'startDate',
      link: {name:'',phone:'',wechat:'',category:'default'},
      selected: 0,
      has_submit: false,
      agree: false,
      showTips: false,
      showAddLink: false,
      showPostCard: false,
      loading: false,
      links: userStore.links,
      hasMore: userStore.linksHasMore
    };
    this.onDatesChange = this.onDatesChange.bind(this);
    this.productPay = this.productPay.bind(this);
    this.handleChange = this.handleChange.bind(this)
    this.handleCustomerChange = this.handleCustomerChange.bind(this)
    this.clickLink = this.clickLink.bind(this)
    this.addLink = this.addLink.bind(this)
    this.onLinksChange = this.onLinksChange.bind(this)
    this.togglePostCard = this.togglePostCard.bind(this)
  }
  clickLink(link){
    let index = this.state.links.indexOf(link)
    let links = this.state.links.concat()
    if(links[index].active){
      this.state.selected--;
    }else{
      this.state.selected++;
    }
    links[index].active = !links[index].active
    this.setState({
      links: links
    })
  }
  handleChange(event){
    let state = {};
    state[event.target.name] = !this.state[event.target.name];
    this.setState(state);
  }
  handleCustomerChange(event) {
    let {name,value} = event.target;
    let link = this.state.link;
    link[name] = value.replace(/(^\s*)|(\s*$)/g, "");
    this.setState({link: link});
  }
  addLink(){
    this.setState({has_submit: true})
    let link = this.state.link
    for(let key in link){
      if(!link[key]){
        return;
      }
    }
    this.setState({loading: true})
    let params = {
      method: 'POST',
      headers: API.jsonHeader,
      body: JSON.stringify(link)
    };
    let self = this
    fetch(API.postLink, params)
      .then(res=>res.json())
      .then(json=>{
        self.setState({loading: false})
        if(json.status == 0){
          self.setState({
            link: {name:'',phone:'',wechat:'',category:'default'},
            loading: false,
            has_submit: false,
            showAddLink: false
          })

          UserActions.clearData('links');
          UserActions.fetchLinks();
        }
      });
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }
    window.scrollTo(0, 0);

    UserStore.listen(this.onLinksChange);
    UserActions.clearData('links');
    UserActions.fetchLinks();

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onLinksChange);
  }
  onLinksChange(state) {
    this.setState({
      links: state.links,
      loading: state.linksLoading,
      hasMore: state.linksHasMore
    });
  }
  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate});
  }
  togglePostCard(){
    this.setState({
      showPostCard: !this.state.showPostCard
    })
  }
  productPay() {
    if(!this.state.agree) return
    if(this.state.loading) return
    let check = API.checkToken;
    if(check) {
      let links = this.state.links
      let link_ids = []
      for (let index = 0; index < links.length; index++) {
        const element = links[index];
        if(element.active){
          link_ids.push(element._id)
        }
      }
      if(!link_ids.length){
        return alert("请选择至少一位出行人")
      }
      this.setState({loading: true})
      let params = {
        method: 'POST',
        headers: API.jsonHeader
      };
      if(this.state.team&&this.state.team._id){
        params.body = JSON.stringify({
          accessToken: API.accessToken,
          start_date: this.state.team.start_date,
          end_date: this.state.team.end_date,
          links: JSON.stringify(link_ids),
          team_id: this.state.team._id
        })
      }else{
        params.body = JSON.stringify({
          accessToken: API.accessToken,
          start_date: this.state.startDate.format('YYYY-MM-DD'),
          end_date: this.state.endDate.format('YYYY-MM-DD'),
          links: JSON.stringify(link_ids)
        })
      }

      let product_id = this.state.product._id;
      let self = this
      fetch(API.postProductPay.replace(':id', product_id), params)
        .then(res=>res.json())
        .then(json=>{
          self.setState({loading: false})
          function onBridgeReady(){
            window.WeixinJSBridge.invoke('getBrandWCPayRequest', json.options, function(res){
              if(res.err_msg === "get_brand_wcpay_request：ok" || res.err_msg.indexOf("ok") !== -1 ) {
                browserHistory.push('/result/pay');
              }
            });
          }
          if (typeof WeixinJSBridge === "undefined"){
            if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
          } else {
            onBridgeReady();
          }
        });
    }
  }

  render(){
    let {state} = this.props.location;
    let {product}  = state;
    let tips, addLink, postCardReveal;
    if(this.state.showTips){
      tips = (
        <div className="tips">
          <ul>
            <li>该占位费将折算为行程总费用</li>
            <li>若拼团成功，团员自主脱团，该费用不予退还</li>
            <li>若拼团失败，全额退款</li>
          </ul>
        </div>
      )
    }

    if(this.state.showAddLink){
      addLink = (
        <div className="customer">
          <div className={(this.state.has_submit&&this.state.link.category=='default')?'alert':''}>
            <select name="category" value={this.state.link.category} onChange={this.handleCustomerChange}>
              <option value="default" disabled>选择联系人类别</option>
              <option value="adult">成人</option>
              <option value="child">儿童</option>
            </select>
          </div>
          <div className={(this.state.has_submit&&!this.state.link.name)?'alert':''}>
            <input type="text" name="name" value={this.state.link.name} onChange={this.handleCustomerChange} placeholder="真实姓名(必填)"  />
          </div>
          <div className={(this.state.has_submit&&!this.state.link.phone)?'alert':''}>
            <input type="text" name="phone" value={this.state.link.phone} onChange={this.handleCustomerChange} placeholder="手机号(必填)" />
          </div>
          <div className={(this.state.has_submit&&!this.state.link.wechat)?'alert':''}>
            <input type="text" name="wechat" value={this.state.link.wechat} onChange={this.handleCustomerChange} placeholder="微信号(必填)" />
          </div>
          <div className="confirm" onClick={this.addLink}>确认添加</div>
        </div>
      )
    }

    if(this.state.showPostCard&&this.state.product._id){
      const texts = this.state.product.title.split('|')
      let desc = texts[1]
      if (this.state.team&&this.state.team._id) {
        desc = `团期：${this.state.team.start_date} ~ ${this.state.team.end_date}`
      }

      postCardReveal = <PostCardComponent
                         title = {texts[0]}
                         desc = {desc}
                         url = {location.href.replace('checkout','route')}
                         cover = {this.state.product.cover.big}
                         togglePostCard = {this.togglePostCard}
                       />
    }

    return (
      <div className="checkout-component">
        <div className='sweet-loading'>
          <BounceLoader
            sizeUnit={"px"}
            size={50}
            color={'#333'}
            loading={this.state.loading}
          />
        </div>
        <div className="product card">
          <div className="image left float">
            <img src={product?product.cover.big:''} className="cover"></img>
          </div>
          <div className="detail right float">
            <div className="title">{product?product.title:''}</div>
            <div className="price">{product?product.price:0}&nbsp;起</div>
          </div>
          <div className="clear"></div>
        </div>
        <div className="date card">
          <p className="cat">出行日期</p>
          {(this.state.team&&this.state.team._id)?<div className="time">{this.state.team.start_date}&nbsp;~&nbsp;{this.state.team.end_date}</div>:(
            <DayPickerRangeController
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onDatesChange={this.onDatesChange}
              focusedInput={this.state.focusedInput}
              onFocusChange={focusedInput => this.setState({ focusedInput: focusedInput})}
              endDateOffset={day => day.add(product.days?product.days:12, 'days')}
              isOutsideRange={(day) => day.isBefore(Moment())}
              monthFormat={'YYYY年 MM月'}
              renderCalendarInfo={() => (
                <CustomInfoPanel />
              )}
            />
          )}
        </div>
        <div className="links card">
          <div className="cat">选择出行人</div>
          <div className="links-wrap">
            {this.state.links.length?this.state.links.map(link => {
              if(link.name||link.first_name||link.last_name){
                return (
                  <div key={link._id} className={link.active?'link active':'link'} onClick={this.clickLink.bind(this,link)}>
                    {link.name?link.name:`${link.last_name} ${link.first_name}`}
                  </div>
                )
              }
            }):null}
            {this.state.hasMore?<div className="link" onClick={() => UserActions.fetchLinks()}>显示更多</div>:null}
            <div className={this.state.showAddLink?'link active':'link'} onClick={() => this.setState({showAddLink: !this.state.showAddLink})}>+ 添加</div>
            <div className="clear"></div>
          </div>
          {addLink}
        </div>
        <div className="agreement card">
          <div className="cat">协议条款</div>
          <div className="checkbox-wrap">
            <input type="checkbox" name="agree" id="agree" checked={this.state.agree} onChange={this.handleChange.bind(this)}/>
            <label style={{verticalAlign: 'middle'}} htmlFor="agree">我同意小地球旅行<a href="javascript:void(0)" name="showTips" onClick={this.handleChange.bind(this)}>占位费协议</a></label>
          </div>
          {tips}
        </div>
        {postCardReveal}
        <div className="bottom"></div>
        <Navigator action='share' number={4} callback={this.togglePostCard}/>
        <Navigator action='top' number={3} />
        <Navigator action='left' number={2}/>
        <div className="actions">
          <div className="price action columns small-7">
            占位费：¥{this.state.product.deposit * (this.state.selected)}
          </div>
          <div className="order action columns small-5" style={!this.state.agree?{opacity:'0.4',color:'hsla(0,0%,100%,.6)'}:{}} onClick={this.productPay}>支付</div>
        </div>
      </div>
    );
  }
}

export default CheckoutComponent;




// WEBPACK FOOTER //
// ./src/develop/CheckoutComponent.js